import { useEffect } from 'react'
import { camelCase } from './camel-case'

import { useSelectors } from '../store'
import { useServicesApi } from '../store/hooks/use-services-api'

// Look up live customer-facing prices on the marketing pages (services
// page, services-plans matrix, services-extra cards). Live only - there are
// no hardcoded fallback prices; the DB (/api/v2/services) is the single
// source of truth. Returns null until the fetch resolves, and callers render
// a skeleton in the meantime (see PriceText).
//
// The Redux store keys services by camelCase(name) - see reducer.js. We
// camelCase the lookup name so casing/spacing differences between marketing
// copy and DB names (e.g. "Basic body wax" vs "Basic Body Wax") don't matter.
// Marketing names are kept in exact sync with the DB names so every lookup
// resolves (no silent fall-through to a missing price).
export const useLivePrice = () => {
  const { apiServicesFetchAll } = useServicesApi()
  const { prices } = useSelectors()

  useEffect(() => {
    if ((prices?.ids?.length || 0) === 0) apiServicesFetchAll()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // servicesAdapter rewrites the API's snake_case `customer_price` to
  // camelCase `customerPrice` before it lands in Redux - so we read the
  // adapter's name here, not the wire name. null = not loaded yet.
  return name => prices?.byName?.[camelCase(name)]?.customerPrice || null
}
